/* eslint-disable jsx-a11y/anchor-is-valid */
import {BaseSyntheticEvent, FC, useState, useEffect} from 'react'
import {PageTitle} from '../../../../../_metronic/layout/core'
import {Input} from '../../../../components/Input/Input'
import {Button} from '../../../../components/Button/Button'
import {useNavigate} from 'react-router-dom'
import {GET, POST} from '../../../../services/api'
import {Loading} from '../../../../components/Loading/Loading'
import Swal from 'sweetalert2'
import useAuth from '../../../../hooks/useAuth'
import {i18n} from '../../../../translate/i18n'
import {ContentModalDescriptionIA} from '../../../../components/ContentModalDescriptionIA'
import uuid from 'react-uuid'
import {ModalImagemCropped} from '../../../../components/Modals/ImagemCropped/ImagemCropped'
import useModals from '../../../../hooks/useModals'
import {BreadCrumbs} from '../../../../components/BreadCrumbs/breadCrumbrs'
import {ModalWrapper} from '../../../../components/Modals/General/ModalWrapper/ModalWrapper'
import {ContentModalImageIA, ImageIAResponseType} from '../../../../components/ContentModalImageIA'

import usePluginSpace from '../../../../hooks/usePluginSpace'

type ReturnType = {
  id: string
  parent: string
  code: string
  name: string
  description: string
  value: string
  select: string
}

type PluginconfigType = {
  id: number
  name: string
  content: any
  plugintemplateId: number
  plugintypeId: number
}

type TemplateType = {
  id: number
  name: string
  image: string | null
  parameters: string
  plugintypeId: number
  pluginconfig: PluginconfigType
  typeIntegration: string
  able: boolean | null
}

type SelectType = {
  value: string | number
  label: string
}

// interface CustomerGroup {
//   id: number
//   pluginspaceId: number
//   name: string
//   created: string
//   updated: string | null
//   deleted: string | null
// }

// interface GroupResponseData {
//   id: string
//   pluginspaceId: number
//   productId: number
//   customerGroupId: number
//   createdAt: string | null
//   deletedAt: string | null
//   customerGroup: CustomerGroup
// }

const CriarProdutosContent: FC = () => {
  const navigate = useNavigate()

  const {showImageCropped, showWrapperModal} = useModals()
  const {loginInfo} = useAuth()
  const [listClassification, setListClassification] = useState<any[]>([])
  const [loading, setLoading] = useState(false)
  const [categoryId, setCategoryId] = useState<string>('0')
  const [categories, setCategories] = useState<any[]>([])
  const [subcategoryId, setSubcategoryId] = useState<string>('0')
  const [name, setName] = useState<string>('')
  const [code, setCode] = useState<string>()
  const [description, setDescription] = useState<string>('')
  const [technicalSpecification, setTechnicalSpecification] = useState<string>('')
  const [marks, setMarks] = useState<any[]>([])
  const [markId, setMarkId] = useState<string>('0')
  const [measurements, setMeasurements] = useState<any[]>([])
  const [measurementId, setMeasurementId] = useState<string>('')
  const [order, setOrder] = useState<string>('0')
  const [status, setStatus] = useState<boolean>(true)
  const [image, setImage] = useState<File | string | null>(null)
  const [originalImageFile, setOriginalImageFile] = useState<File | null>(null)
  const [extraImages, setExtraImages] = useState<FileList>()

  const [imageCrop, setImageCrop] = useState<string | null>('')
  const [isCropped, setCropper] = useState<any>(null)
  const [canAlert, setCanAlert] = useState(false)

  const [pluginIA, setPluginIA] = useState('')
  const [showDescriptionIAModal, setShowDescriptionIAModal] = useState(false)
  const [imageIaSelected, setImageIaSelected] = useState<ImageIAResponseType>()
  const [canSave, setCanSave] = useState(false)

  /** Variavel usada para saber se é atacado */
  const {getPluginSpace} = usePluginSpace()
  const [isWholeSaler, setIsWholeSaler] = useState(false)
  /** Caso seja atacado, recuperar grupos e grupos associados a esse produto */
  const [groups, setGroups] = useState<
    {
      created: string
      deleted: string
      id: number
      name: string
      pluginspaceId: number
      updated: string
    }[]
  >([])
  const [groupsAssociated, setGroupsAssociated] = useState<SelectType[]>([])

  async function getCustomersGroups() {
    try {
      const thisPluginsSpace = await getPluginSpace(true)

      const isWholeSaler = thisPluginsSpace && thisPluginsSpace.wholeSaler

      if (isWholeSaler) {
        setIsWholeSaler(true)
        const res = await GET('/customer_groups')
        if (res && res.data) {
          setGroups(res.data)
        }
      }
    } catch (error) {}
  }

  const generateClassificationTree = (
    categories: ReturnType[],
    parent: string | null,
    name: string
  ): any => {
    const parentCategory = categories.find((category) => category.code === parent)
    if (parentCategory)
      return `${generateClassificationTree(
        categories,
        parentCategory.parent,
        parentCategory.name
      )} > ${name}`
    else return name
  }

  const getCategories = async () => {
    try {
      const res = await GET(`/classification`)
      res.data.forEach((row: ReturnType) => {
        listClassification.push({
          id: row.id,
          parent: row.parent,
          code: row.code,
          name: generateClassificationTree(res.data, row.parent, row.name),
        })
      })
      const categories = [
        {
          value: '0',
          select: 'Selecione',
          key: -1,
        },
      ]
      listClassification.forEach((row: any, idx) => {
        categories.push({
          value: row.id,
          select: row.name,
          key: idx,
        })
      })
      setCategories(categories)
    } catch (e) {
      console.log(e)
    }
  }

  const getMarks = async () => {
    try {
      const res = await GET('/mark')
      const marks = [
        {
          value: '0',
          select: 'Selecione',
        },
      ]
      res.data.forEach((row: ReturnType) => {
        marks.push({
          value: row.id,
          select: row.name,
        })
      })
      setMarks(marks)
    } catch (e) {
      console.log(e)
    }
  }

  const getMeasurements = async () => {
    try {
      const res = await GET('/measurement')
      const measurements = [
        {
          value: '0',
          select: 'Selecione',
        },
      ]
      res.data.forEach((row: ReturnType) => {
        measurements.push({
          value: row.id,
          select: row.description,
        })
      })
      setMeasurements(measurements)
    } catch (e) {
      console.log(e)
    }
  }

  const createProduct = async () => {
    const subcategorySelected: any = subcategoryId
    try {
      if (
        // eslint-disable-next-line eqeqeq
        subcategoryId == '0' ||
        subcategorySelected.value === '0' ||
        !name ||
        !description ||
        // eslint-disable-next-line eqeqeq
        markId == '0' ||
        // eslint-disable-next-line eqeqeq
        measurementId == '0'
      ) {
        setCanAlert(true)
        Swal.fire({
          icon: 'error',
          title: 'Campos faltantes',
          text: 'Verifique se preencheu todos os campos!',
        })
        return
      } else {
        if (!code) {
          setCanAlert(true)
          Swal.fire({
            icon: 'warning',
            title: 'Código não pode ser vazio',
            text: 'Verifique se preencheu todos os campos!',
          })
          return
        }
        setLoading(true)
        const data = {
          name: name,
          description: description,
          order: parseInt(order),
          code: code ?? '',
          classificationId: parseInt(subcategorySelected.value),
          type: 'product',
          status: status,
          measurementUnitId: parseInt(measurementId),
          parent: '',
          markId: parseInt(markId),
          technicalSpecification: technicalSpecification,
        }

        const resProd = await POST('/product', data)
        if (resProd.success === true) {
          let imageRes = {
            success: false,
            image: '',
          }
          if (image) {
            if (imageIaSelected?.url) {
              imageRes.success = true
              imageRes.image = image.toString()
            } else {
              const formData = new FormData()

              // Verificar se a imagem tem dados de formato especiais
              let fileToUpload = image
              let hasFormatData = false

              if (image && typeof image === 'object' && image.hasOwnProperty('_formatData')) {
                const imageWithFormat = image as any
                if (imageWithFormat._formatData && imageWithFormat._formatData.file) {
                  fileToUpload = imageWithFormat._formatData.file
                  hasFormatData = true
                  // Usar as dimensões do formato selecionado
                  formData.append('width', imageWithFormat._formatData.width.toString())
                  formData.append('height', imageWithFormat._formatData.height.toString())
                }
              }

              formData.append('file', fileToUpload)
              formData.append('nameImage', `product-${uuid()}.jpg`)

              // Detectar dimensões automaticamente apenas se não tiver dados de formato
              if (
                !hasFormatData &&
                typeof fileToUpload !== 'string' &&
                fileToUpload instanceof File
              ) {
                const img = new Image()
                const objectUrl = URL.createObjectURL(fileToUpload)

                await new Promise((resolve) => {
                  img.onload = () => {
                    formData.append('width', img.width.toString())
                    formData.append('height', img.height.toString())
                    URL.revokeObjectURL(objectUrl)
                    resolve(void 0)
                  }
                  img.src = objectUrl
                })
              }

              imageRes = await POST('/upload-images/upload-one', formData)
            }
          }
          // eslint-disable-next-line eqeqeq
          if (imageRes.success == true) {
            const data = [
              {
                path: imageRes.image,
                productId: resProd.dados.id,
                typeimg: 'imgsmall',
                order: 0,
              },
              {
                path: imageRes.image,
                productId: resProd.dados.id,
                typeimg: 'mainpicture',
                order: 0,
              },
              {
                path: imageRes.image,
                productId: resProd.dados.id,
                typeimg: 'thumbpicture',
                order: 0,
              },
            ]
            if (extraImages) {
              await Promise.all(
                Array.from(extraImages).map(async (image) => {
                  let imageExtraRes = {
                    success: false,
                    image: '',
                  }
                  const formData = new FormData()
                  formData.append('file', image)
                  formData.append('nameImage', `product-${uuid()}.jpg`)

                  // Detectar dimensões automaticamente para imagens extras
                  if (image instanceof File) {
                    const img = new Image()
                    const objectUrl = URL.createObjectURL(image)

                    await new Promise((resolve) => {
                      img.onload = () => {
                        formData.append('width', img.width.toString())
                        formData.append('height', img.height.toString())
                        URL.revokeObjectURL(objectUrl)
                        resolve(void 0)
                      }
                      img.src = objectUrl
                    })
                  }

                  imageExtraRes = await POST('/upload-images/upload-one', formData)
                  if (imageExtraRes.success === true) {
                    data.push({
                      path: imageExtraRes.image,
                      productId: resProd.dados.id,
                      typeimg: 'image',
                      order: 0,
                    })
                  }
                })
              )
            }
            await POST('/productimage/multiple', {
              data,
            })
          }

          if (isWholeSaler) {
            await POST('/product-customer-group', {
              productId: resProd.dados.id,
              customerGroups: groupsAssociated.map((group) => group.value),
            })
          }

          setCanAlert(false)
          Swal.fire({
            icon: 'success',
            title: 'Produto cadastrado',
            text: 'Cadastro realizado com sucesso!',
          }).then(() =>
            navigate(
              `${loginInfo.plugintype === 'varejo' ? '/product_varejo' : '/product_fashion'}`
            )
          )
        } else {
          setCanAlert(true)
          Swal.fire({
            icon: 'error',
            title: 'Erro',
            text: 'Erro ao cadastrar o produto!',
          })
        }
        setLoading(false)
      }
    } catch (e) {
      setCanAlert(true)
      setLoading(false)
      console.log(e)
      Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: 'Erro ao cadastrar o produto!',
      })
    }
  }

  const getCropData = async () => {
    if (isCropped) {
      const file = await fetch(isCropped.getCroppedCanvas().toDataURL())
        .then((res) => res.blob())
        .then((blob) => {
          return new File([blob], 'newAvatar.png', {type: 'image/png'})
        })

      setImage(file)
      setImageCrop('')
    }
  }

  const useOriginalImage = () => {
    if (originalImageFile) {
      setImage(originalImageFile)
      setImageCrop('')
    }
  }

  const useSelectedSize = (width: number, height: number) => {
    if (originalImageFile) {
      // Criar uma cópia do arquivo original com metadados especiais
      const imageWithFormat = Object.assign(originalImageFile, {
        _formatData: {
          file: originalImageFile,
          width: width,
          height: height,
          isFormatted: true,
        },
      })

      setImage(imageWithFormat)
      setImageCrop('')
    }
  }

  const getImagetoCrop = (e: any) => {
    if (e?.target.files) {
      setOriginalImageFile(e.target.files[0]) // Armazenar arquivo original
      showImageCropped()
      setImageCrop(URL.createObjectURL(e.target.files[0]))
    }
  }

  const verifyIA = async () => {
    const templateRes = await GET('/plugintemplate/ia')
    if (templateRes && templateRes.data) {
      templateRes.data.forEach((template: TemplateType) => {
        if (template.pluginconfig) {
          if (
            template.pluginconfig.content &&
            template.pluginconfig.content.able &&
            template.pluginconfig.content.able !== '0'
          ) {
            setPluginIA(template.pluginconfig.content.modelId)
          }
        }
      })
    }
  }

  const handleUnload = (e: BeforeUnloadEvent) => {
    e.preventDefault()
    e.returnValue = true
    localStorage.removeItem('product-saved')
  }

  const init = async () => {
    setLoading(true)
    const load = async () => {
      try {
        await getCategories()
        await getCustomersGroups()
        await getMarks()
        await getMeasurements()
        setCanSave(true)
      } catch (error) {
        console.log(error)
      } finally {
        setLoading(false)
      }
    }
    await verifyIA()
    const productSaved = localStorage.getItem('product-saved')
    if (productSaved && JSON.parse(productSaved)) loadLocal()
    else await load()
    setLoading(false)
  }

  useEffect(() => {
    init()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    return () => {
      if (
        canAlert &&
        !window.location.pathname.includes(
          `/${loginInfo.plugintype === 'varejo' ? 'product_varejo' : 'product_fashion'}/criar`
        )
      ) {
        Swal.fire({
          title: 'Sair da página?',
          text: 'Há alterações não salvas que serão perdidas se você sair da página.',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Sair',
          cancelButtonText: 'Continuar editando',
        }).then((result) => {
          if (!result.isConfirmed) {
            navigate(
              `/${loginInfo.plugintype === 'varejo' ? 'product_varejo' : 'product_fashion'}/criar`
            )
          } else {
            localStorage.removeItem('product-saved')
          }
        })
      } else if (!canAlert) localStorage.removeItem('product-saved')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.location.pathname, canAlert])

  const loadLocal = () => {
    const prouctSaved = localStorage.getItem('product-saved')
    if (prouctSaved && JSON.parse(prouctSaved)) {
      const jsonProduct = JSON.parse(prouctSaved)
      setListClassification(jsonProduct.listClassification)
      setCategoryId(jsonProduct.categoryId)
      setCategories(jsonProduct.categories)
      setSubcategoryId(jsonProduct.subcategoryId)
      setName(jsonProduct.name)
      setCode(jsonProduct.code)
      setDescription(jsonProduct.description)
      setTechnicalSpecification(jsonProduct.technicalSpecification)
      setMarks(jsonProduct.marks)
      setMarkId(jsonProduct.markId)
      setMeasurements(jsonProduct.measurements)
      setMeasurementId(jsonProduct.measurementId)
      setOrder(jsonProduct.order)
      setStatus(jsonProduct.status)
      if (typeof jsonProduct.image === 'string') setImage(jsonProduct.image)
      localStorage.removeItem('product-saved')
    }
  }

  const saveLocal = () => {
    localStorage.setItem(
      'product-saved',
      JSON.stringify({
        listClassification,
        categoryId,
        categories,
        subcategoryId,
        name,
        code,
        description,
        technicalSpecification,
        marks,
        markId,
        measurements,
        measurementId,
        order,
        status,
        image,
      })
    )
  }

  useEffect(() => {
    if (canSave) saveLocal()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    listClassification,
    categoryId,
    categories,
    subcategoryId,
    name,
    code,
    description,
    technicalSpecification,
    marks,
    markId,
    measurements,
    measurementId,
    order,
    status,
    image,
  ])

  useEffect(() => {
    window.addEventListener('beforeunload', handleUnload)
    return () => window.removeEventListener('beforeunload', handleUnload)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <div className='row g-5 gx-xxl-12 pb-5'>
          <div className='d-flex justify-content-between flex-wrap w-100 gap-5'>
            <div className='me-5' style={{flex: 1}}>
              <div className='card pb-5'>
                <div className='card-header py-5'>
                  <h3 className='card-title align-items-start flex-column'>
                    <span className='card-label fw-bold fs-4 mb-1'>
                      {i18n.t(`smart_order.product_data`)}
                    </span>
                    <BreadCrumbs />
                  </h3>
                </div>
                <div className='px-10 py-5'>
                  <Input
                    inputAttr={{
                      type: 'select',
                    }}
                    search
                    label={i18n.t(`smart_order.category`)}
                    options={categories}
                    value={subcategoryId}
                    change={(value: string) => {
                      setCanAlert(true)
                      setSubcategoryId(value)
                    }}
                  />
                  <Input
                    inputAttr={{
                      type: 'select',
                    }}
                    label={i18n.t(`smart_order.mark`)}
                    options={marks}
                    value={markId}
                    change={(value: string) => {
                      setCanAlert(true)
                      setMarkId(value)
                    }}
                  />
                  <Input
                    inputAttr={{
                      type: 'select',
                    }}
                    label={i18n.t(`smart_order.measurement_unit`)}
                    options={measurements}
                    value={measurementId}
                    change={(value: string) => {
                      setCanAlert(true)
                      setMeasurementId(value)
                    }}
                  />
                  <Input
                    inputAttr={{
                      type: 'default',
                    }}
                    placeholder={i18n.t(`smart_order.name`)}
                    label={i18n.t(`smart_order.name`)}
                    value={name}
                    change={(value: string) => {
                      setCanAlert(true)
                      setName(value)
                    }}
                  />
                  <Input
                    inputAttr={{
                      type: 'default',
                    }}
                    placeholder={i18n.t(`smart_order.code`)}
                    label={i18n.t(`smart_order.code`)}
                    value={code}
                    change={(value: string) => {
                      setCanAlert(true)
                      setCode(value)
                    }}
                  />

                  {/* Campo de descrição */}
                  <div className='mb-3'>
                    <Input
                      inputAttr={{
                        type: 'textarea',
                      }}
                      placeholder={i18n.t(`smart_order.description`)}
                      label={i18n.t(`smart_order.description`)}
                      value={description}
                      change={(value: string) => {
                        setCanAlert(true)
                        setDescription(value)
                      }}
                      rows={5}
                      maxCaracteres={415}
                    />

                    {/* Botão IA Avançada */}
                    {pluginIA && pluginIA !== '' && (
                      <div className='d-flex justify-content-start mt-2'>
                        <Button
                          text='Descrição Avançada com IA'
                          color='primary'
                          size='small'
                          horizontalPadding={3}
                          svgIcon={
                            <svg
                              width='15'
                              height='15'
                              viewBox='0 0 15 15'
                              fill='none'
                              xmlns='http://www.w3.org/2000/svg'
                            >
                              <path
                                d='M6.39844 1.92578L6.78125 0.886719C6.80859 0.804688 6.89062 0.75 7 0.75C7.08203 0.75 7.16406 0.804688 7.19141 0.886719L7.57422 1.92578L8.61328 2.30859C8.69531 2.33594 8.75 2.41797 8.75 2.5C8.75 2.60938 8.69531 2.69141 8.61328 2.71875L7.57422 3.10156L7.19141 4.11328C7.16406 4.19531 7.08203 4.25 7 4.25C6.89062 4.25 6.80859 4.19531 6.78125 4.11328L6.39844 3.10156L5.38672 2.71875C5.30469 2.69141 5.25 2.60938 5.25 2.5C5.25 2.41797 5.30469 2.33594 5.38672 2.30859L6.39844 1.92578ZM12.6055 2.0625L9.59766 5.07031L10.5547 6.02734L13.5625 3.01953L12.6055 2.0625ZM2.1875 12.5078L3.11719 13.4375L9.625 6.95703L8.66797 6L2.1875 12.5078ZM11.6758 1.16016C12.1953 0.640625 13.0156 0.640625 13.5352 1.16016L14.4648 2.08984C14.9844 2.60938 14.9844 3.42969 14.4648 3.94922L4.04688 14.3672C3.52734 14.8867 2.70703 14.8867 2.1875 14.3672L1.25781 13.4375C0.738281 12.918 0.738281 12.0977 1.25781 11.5781L11.6758 1.16016ZM0.191406 3.97656L1.75 3.375L2.32422 1.84375C2.35156 1.70703 2.48828 1.625 2.625 1.625C2.73438 1.625 2.87109 1.70703 2.89844 1.84375L3.5 3.375L5.03125 3.97656C5.16797 4.00391 5.25 4.14062 5.25 4.25C5.25 4.38672 5.16797 4.52344 5.03125 4.55078L3.5 5.125L2.89844 6.68359C2.87109 6.79297 2.73438 6.875 2.625 6.875C2.48828 6.875 2.35156 6.79297 2.32422 6.68359L1.75 5.125L0.191406 4.55078C0.0820312 4.52344 0 4.38672 0 4.25C0 4.14062 0.0820312 4.00391 0.191406 3.97656ZM9.81641 10.9766L11.375 10.375L11.9492 8.84375C11.9766 8.70703 12.1133 8.625 12.25 8.625C12.3594 8.625 12.4961 8.70703 12.5234 8.84375L13.125 10.375L14.6562 10.9766C14.793 11.0039 14.875 11.1406 14.875 11.25C14.875 11.3867 14.793 11.5234 14.6562 11.5508L13.125 12.125L12.5234 13.6836C12.4961 13.793 12.3594 13.875 12.25 13.875C12.1133 13.875 11.9766 13.793 11.9492 13.6836L11.375 12.125L9.81641 11.5508C9.70703 11.5234 9.625 11.3867 9.625 11.25C9.625 11.1406 9.70703 11.0039 9.81641 10.9766Z'
                                fill='white'
                              />
                            </svg>
                          }
                          btnAttr={{
                            type: 'button',
                          }}
                          click={() => setShowDescriptionIAModal(true)}
                          btnClass='fw-bolder d-flex flex-row gap-1 align-items-center'
                          txtClass='text-nowrap text-white'
                          outline={false}
                          disabled={!name}
                        />
                      </div>
                    )}
                  </div>
                  <p className='mt-2'>
                    <small>
                      {description.length} {i18n.t(`smart_order.from`)} 415{' '}
                      {i18n.t(`smart_order.characters`)}
                    </small>
                  </p>

                  <Input
                    inputAttr={{
                      type: 'textarea',
                    }}
                    placeholder={i18n.t(`smart_order.technical_specification`)}
                    label={i18n.t(`smart_order.technical_specification`)}
                    value={technicalSpecification}
                    change={(value: string) => {
                      setCanAlert(true)
                      setTechnicalSpecification(value)
                    }}
                    rows={5}
                    maxCaracteres={415}
                  />
                  <p className='mt-2'>
                    <small>
                      {technicalSpecification.length} {i18n.t(`smart_order.from`)} 415{' '}
                      {i18n.t(`smart_order.characters`)}
                    </small>
                  </p>
                  <Input
                    inputAttr={{
                      type: 'select',
                    }}
                    label='Status'
                    options={[
                      {select: i18n.t(`general.active`), value: true},
                      {select: i18n.t(`general.inactive`), value: false},
                    ]}
                    value={status}
                    change={(value: boolean) => {
                      setCanAlert(true)
                      setStatus(value)
                    }}
                  />
                  <Input
                    inputAttr={{
                      type: 'default',
                    }}
                    placeholder={i18n.t(`smart_order.order`)}
                    label={i18n.t(`smart_order.order`)}
                    smalltext='(para exibição no webapp)'
                    value={order}
                    change={(value: string) => {
                      setCanAlert(true)
                      setOrder(value)
                    }}
                  />
                </div>
              </div>
            </div>

            <div>
              <div className='card pb-5'>
                <div className='card-header py-5'>
                  <h3 className='card-title align-items-start flex-column'>
                    <span className='card-label fw-bold fs-4 mb-1'>
                      {i18n.t(`smart_order.product_image`)}
                    </span>
                  </h3>
                </div>
                <div className='d-flex justify-content-center w-100'>
                  <div className='px-10 py-5'>
                    {
                      /*
                    <Input
                      inputAttr={{
                        type: 'image',
                      }}
                      value={image}
                      change={(value: BaseSyntheticEvent) =>
                        setImage(value ? value.target.files[0] : null)
                      }
                    />
                    */
                      <>
                        <Input
                          inputAttr={{
                            type: 'image',
                          }}
                          action={() => {
                            showWrapperModal(i18n.t('smart_order.create_image_ia'))
                          }}
                          value={image}
                          generateValueIA={
                            pluginIA && pluginIA !== ''
                              ? {
                                  modelId: pluginIA,
                                  prompt: '',
                                  action: 'create',
                                }
                              : undefined
                          }
                          change={(value: BaseSyntheticEvent) => {
                            setCanAlert(true)
                            setImage(value ? value.target.files[0] : null)
                            if (value) {
                              getImagetoCrop(value ? value : null)
                            } else {
                              setImageCrop('')
                              getImagetoCrop(null)
                            }
                          }}
                        />
                      </>
                    }
                  </div>
                </div>
              </div>

              <div className='card mt-4 pb-5'>
                <div className='card-header py-5'>
                  <h3 className='card-title align-items-start flex-column'>
                    <span className='card-label fw-bold fs-4 mb-1'>
                      {i18n.t(`smart_order.additional_images`)}
                    </span>
                  </h3>
                </div>
                <div className='d-flex justify-content-center w-100'>
                  <div className='px-10 py-5'>
                    <input
                      type='file'
                      accept='.jpg, .jpeg, .png'
                      multiple
                      onChange={(e) => {
                        if (e.target.files && e.target.files.length <= 3) {
                          setCanAlert(true)
                          setExtraImages(e.target.files)
                        } else {
                          e.target.value = ''
                          Swal.fire({
                            icon: 'warning',
                            title: 'Atenção!',
                            text: 'O limite de imagens adicionais é de no máximo 3 arquivos.',
                          })
                        }
                      }}
                    />
                  </div>
                </div>
                <div className='d-flex justify-content-center w-100'>
                  {extraImages &&
                    Array.from(extraImages).map((image) => {
                      return (
                        <div className='px-10 py-5'>
                          <div className=' mt-1 w-150px'>
                            <div className='w-150px h-150px rounded'>
                              <img
                                className='w-100 h-100'
                                src={URL.createObjectURL(image)}
                                alt=''
                              />
                            </div>
                          </div>
                        </div>
                      )
                    })}
                </div>
              </div>

              {isWholeSaler && (
                <div className='card mt-4 pb-5'>
                  <div className='card-header py-5'>
                    <h3 className='card-title align-items-start flex-column'>
                      <span className='card-label fw-bold fs-4 mb-1'>
                        {i18n.t(`smart_order.product_groups`)}
                      </span>
                    </h3>
                  </div>
                  <div className='d-flex justify-content-center w-100'>
                    <div className='px-10 py-5'>
                      <Input
                        inputAttr={{
                          type: 'select',
                        }}
                        isMulti
                        search
                        placeholder={i18n.t(`smart_order.product_groups`)}
                        label={i18n.t(`smart_order.product_groups`)}
                        value={groupsAssociated}
                        change={(selectedSeller: SelectType[]) => {
                          setGroupsAssociated(selectedSeller)
                        }}
                        options={groups.map((row) => {
                          return {
                            value: row.id,
                            select: row.name,
                          }
                        })}
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className='card px-10 py-4 col-12 mb-5'>
              <div className='d-flex justify-content-between w-100 '>
                <Button
                  text={i18n.t(`buttons.back`)}
                  color='info'
                  size='small'
                  horizontalPadding={5}
                  btnAttr={{
                    type: 'button',
                  }}
                  click={() => {
                    navigate(
                      `${
                        loginInfo.plugintype === 'varejo' ? '/product_varejo' : '/product_fashion'
                      }`
                    )
                  }}
                  btnClass='fw-bolder me-3'
                />
                <Button
                  text={i18n.t(`buttons.save`)}
                  color='primary'
                  size='small'
                  horizontalPadding={5}
                  btnAttr={{
                    type: 'button',
                  }}
                  click={() => {
                    setCanAlert(false)
                    createProduct()
                  }}
                  btnClass='fw-bolder'
                />
              </div>
            </div>
          </div>

          <ModalWrapper
            confirmAction={() => {}}
            noCloseOverlay={true}
            noCloseButton={true}
            noAction={true}
            width={70}
            maxWidth
          >
            <ContentModalImageIA
              key={'proposeImage'}
              imageReferenceDefault={image}
              description={description}
              setImage={setImage}
              imageIaSelected={imageIaSelected}
              setImageIaSelected={setImageIaSelected}
            />
          </ModalWrapper>
        </div>
      )}

      {/* Modal IA para Descrição */}
      {showDescriptionIAModal && (
        <ModalWrapper
          confirmAction={() => setShowDescriptionIAModal(false)}
          noCloseOverlay={true}
          noCloseButton={true}
          noAction={true}
          width={70}
          maxWidth
        >
          <ContentModalDescriptionIA
            description={description}
            productName={name}
            productImage={typeof image === 'string' ? image : null}
            pluginIA={pluginIA}
            onDescriptionGenerated={(generatedDescription: string) => {
              setDescription(generatedDescription)
              setShowDescriptionIAModal(false)
              setCanAlert(true)

              // Notificação de sucesso
              Swal.fire({
                icon: 'success',
                title: 'Descrição gerada!',
                text: 'A descrição foi gerada com sucesso pela IA.',
                timer: 2000,
                showConfirmButton: false,
              })
            }}
            onCancel={() => setShowDescriptionIAModal(false)}
          />
        </ModalWrapper>
      )}

      <ModalImagemCropped
        imageCrop={imageCrop}
        setCropper={setCropper}
        getCropData={getCropData}
        onUseOriginalImage={useOriginalImage}
        onUseSelectedSize={useSelectedSize}
      />
    </>
  )
}

const CriarProdutos: FC = () => {
  const {loginInfo} = useAuth()
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {title: 'Dashboard', path: 'dashboard', isActive: true},
          {
            title: i18n.t(`smart_order.product`),
            path: loginInfo.plugintype === 'varejo' ? 'product_varejo' : 'product_fashion',
            isActive: true,
          },
          {
            title: i18n.t(`buttons.create`),
            path:
              loginInfo.plugintype === 'varejo' ? 'product_varejo/criar' : 'product_fashion/criar',
            isActive: true,
          },
        ]}
      >
        {`${i18n.t(`buttons.create`)} ${i18n.t(`smart_order.product`)}`}
      </PageTitle>
      <CriarProdutosContent />
    </>
  )
}

export {CriarProdutos}
